import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { combineLatest, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { WordpressServiceExtended } from '../../services/wordpress.api.service';
import { loadWordpress, loadWordpressFailure, loadWordpressSuccess } from './wordpress.actions';
import { WpCommonData } from '../../types/wordpress/common-data.type';
import { WordpressService } from '@streamamg/wordpress-lib';


@Injectable()
export class WordpressEffects {

  loadWordpress$ = createEffect(() => this.actions$.pipe(
    ofType(loadWordpress),
    switchMap(() => combineLatest([
      this.wordPressService.getCommonData<WpCommonData>(),
      this.wordpressServiceExtended.getCategories(),
      this.wordpressServiceExtended.getDocumentaries(),

    ])),
    map(([commonData, categories, documentaries]) => {

      if (categories && commonData && documentaries) {

        return loadWordpressSuccess({
          data: {
            categories,
            commonData,
            documentaries,
          },
        });
      }

      return loadWordpressFailure(null);
    }),
    catchError(error => of(loadWordpressFailure(error))),
  ), {dispatch: true});


  constructor(
    private actions$: Actions,
    private router: Router,
    private wordPressService: WordpressService,
    private wordpressServiceExtended: WordpressServiceExtended,
  ) {
  }
}
